document.addEventListener('DOMContentLoaded', function () {

    // --- Hilfsfunktion: Event Listener sicher hinzufügen (verhindert Duplikate) ---
    function addSafeEventListener(element, eventType, handler, options) {
        const listenerKey = `__${eventType}_handler__`;
        // Alten Listener entfernen, falls vorhanden
        if (element[listenerKey]) {
            element.removeEventListener(eventType, element[listenerKey], options);
        }
        // Neuen Listener hinzufügen und speichern
        element.addEventListener(eventType, handler, options);
        element[listenerKey] = handler;
    }

    // --- Hilfsfunktion: Pixelwert aus CSS-Wert berechnen ---
    function getPixelValue(value, baseElement = document.documentElement) {
        if (typeof value !== 'string') return parseFloat(value) || 0;
        const val = parseFloat(value);
        if (isNaN(val)) return 0;

        if (value.endsWith('px')) return val;
        if (value.endsWith('rem')) return val * parseFloat(getComputedStyle(document.documentElement).fontSize);
        if (value.endsWith('em')) return val * parseFloat(getComputedStyle(baseElement).fontSize); 
        if (value.endsWith('vh')) return val * window.innerHeight / 100;
        if (value.endsWith('vw')) return val * window.innerWidth / 100;
        return val; // Fallback für reine Zahlen oder unbekannte Einheiten
    } 

    // --- Hilfsfunktionen für Breitenberechnung ---
    function applyMaxWidth(stoerer) {
        const content = stoerer.querySelector('.stoerer--content'); 
        if (!content) return;

        if (stoerer.__pendingMaxWidthFrame) {
            cancelAnimationFrame(stoerer.__pendingMaxWidthFrame);
            stoerer.__pendingMaxWidthFrame = null;
        }
        
        const originalTransition = content.style.transition;
        content.style.transition = 'none';
        content.style.maxWidth = 'max-content';
        const scrollWidth = content.scrollWidth;
        content.style.maxWidth = '';
        content.style.transition = originalTransition;

        const widthPx = Math.ceil(scrollWidth);
        stoerer.__pendingMaxWidthFrame = requestAnimationFrame(() => {
            stoerer.__pendingMaxWidthFrame = null;
            if (!stoerer.classList.contains('is-expanded')) {
                return;
            }
            content.style.setProperty('--stoerer-content-max-width', widthPx + 'px');
        });
    }

    function removeMaxWidth(stoerer) {
        if (stoerer.__pendingMaxWidthFrame) {
            cancelAnimationFrame(stoerer.__pendingMaxWidthFrame);
            stoerer.__pendingMaxWidthFrame = null;
        }
        const content = stoerer.querySelector('.stoerer--content');
        if (!content) return;
        content.style.removeProperty('--stoerer-content-max-width');
    }

    // --- Hilfsfunktion: Effektive Trigger-Höhe ermitteln (nutzt bevorzugt CSS Var) ---
    function getTriggerOuterHeightPx(stoererElement) {
        const trigger = stoererElement.querySelector('.stoerer-trigger');

        // 1) Bevorzugt die reale Höhe des Triggers messen (unabhängig von Content-Expansion)
        if (trigger) {
            const h = trigger.getBoundingClientRect().height || trigger.offsetHeight || 0;
            if (h > 0) return h;
        }

        // 2) Fallback: aus Variablen ableiten
        const cs = getComputedStyle(stoererElement);
        let sizeVar = cs.getPropertyValue('--stoerer-size').trim();
        if (window.innerWidth < 768) {
            const mobileVar = cs.getPropertyValue('--stoerer-size-mobile').trim();
            if (mobileVar) sizeVar = mobileVar;
        }
        const sizePx = sizeVar ? getPixelValue(sizeVar, stoererElement) : 0;
        if (sizePx && !isNaN(sizePx) && sizePx > 0) return sizePx;

        // 3) Letzter Fallback
        return 40;
    }

    // --- Vereinfachte State-Verwaltung ---
    class StoererState {
        constructor(element) {
            this.element = element;
            this.isExpanded = false;
            this.isActive = false; // Vereinfacht: nur ein Active-State statt mehrerer
            this.isInteracting = false;
        }

        expand() {
            if (!this.isExpanded) {
                this.isExpanded = true;
                this.element.classList.add('is-expanded');
                applyMaxWidth(this.element);
            }
        }

        collapse() {
            if (this.isExpanded) {
                this.isExpanded = false;
                this.element.classList.remove('is-expanded');
                removeMaxWidth(this.element);

                // Force blur auf allen fokussierbaren Elementen im Störer
                const focusableElements = this.element.querySelectorAll('a, button, input, textarea, select, [tabindex]');
                focusableElements.forEach(el => el.blur());

                // CSS-Hover States explizit zurücksetzen (für alle Geräte)
                this.element.classList.add('force-collapsed');
                // Nach kurzer Zeit wieder entfernen, damit normale Hover-Logic funktioniert
                setTimeout(() => {
                    this.element.classList.remove('force-collapsed');
                }, 100);
            }
        }

        activate() {
            this.isActive = true;
            this.element.classList.add('is-active');
        }

        deactivate() {
            this.isActive = false;
            this.element.classList.remove('is-active');
        }

        setInteracting(state) {
            this.isInteracting = state;
            this.element.classList.toggle('is-interacting', state);
        }
    }

    // --- Globale State-Map ---
    const stoererStates = new Map();

    function getStoererState(element) {
        if (!stoererStates.has(element)) {
            stoererStates.set(element, new StoererState(element));
        }
        return stoererStates.get(element);
    }

    // --- Touch-Device Detection ---
    function isTouchDevice() {
        return ('ontouchstart' in window) ||
               (navigator.maxTouchPoints > 0) ||
               (navigator.msMaxTouchPoints > 0) ||
               (window.innerWidth < 768);
    }

    // --- Mobile/Touch-Handler vereinfacht ---
    function handleTouchClick(event, stoerer) {
        const state = getStoererState(stoerer);

        // Touch-Geräte: Immer Toggle-Verhalten
        if (isTouchDevice()) {
            // Wenn bereits expandiert/aktiv: Schließen
            if (state.isActive || state.isExpanded) {
                state.deactivate();
                state.collapse();
                return true; // Event wurde behandelt
            }
            // Wenn geschlossen: Öffnen
            else {
                event.preventDefault(); // Verhindert Link-Navigation nur beim ersten Klick
                closeAllTouchStates(); // Schließe andere
                state.activate();
                state.expand();
                return true; // Event wurde behandelt
            }
        }

        return false; // Event nicht behandelt, Desktop-Logic verwenden
    }

    function closeAllTouchStates() {
        stoererStates.forEach(state => {
            state.deactivate();
            state.collapse();
        });
    }

    // --- Fixed Störer Stacking optimiert ---
    function stackFixedStoerers() {
        const fixedStoererWrappers = document.querySelectorAll('.is-fixed.content--element.ce_rsce_stoerer');

        fixedStoererWrappers.forEach(wrapper => {
            const stoerers = Array.from(wrapper.querySelectorAll(':scope > .ce--stoerer.is-expandable'));


            if (stoerers.length <= 1) {
                stoerers.forEach(el => {
                    el.style.zIndex = '';
                    // Reset auch die ursprüngliche Position für dynamische Störer
                    if (el.dataset.originalStyleTop && el.dataset.originalStyleTop !== el.style.top) {
                        el.style.top = el.dataset.originalStyleTop;
                    }
                });
                return;
            }

            // Gap-Berechnung (konfigurierbar im Element, Standard .5rem)
            const gapStyle = getComputedStyle(wrapper).getPropertyValue('--stoerer-vertical-gap') || '0.5rem';
            const gapValuePx = getPixelValue(gapStyle.trim(), wrapper);

            // Sort-Keys einmalig vorberechnen (vermeidet getComputedStyle pro Vergleich)
            const isMobile = window.innerWidth < 768;
            const sortKeyMap = new Map();
            stoerers.forEach(el => {
                const isDynamic = el.classList.contains('article-info-nav-stoerer') || el.id === 'stoerer-130-1';
                let topPx = 0;
                let resolvedCustomTop = '';
                if (!isDynamic) {
                    const cs = getComputedStyle(el);
                    let styleTop = el.style.top;
                    let customTop = cs.getPropertyValue('--stoerer-page-top').trim();
                    if (isMobile) {
                        const mobileTop = cs.getPropertyValue('--stoerer-top-mobile').trim();
                        if (mobileTop) customTop = mobileTop;
                    }
                    resolvedCustomTop = customTop;
                    if (customTop) {
                        styleTop = customTop;
                    } else if (!styleTop || styleTop === 'auto' || styleTop === '' || styleTop === '0px') {
                        const computedTop = cs.top;
                        styleTop = (computedTop && computedTop !== 'auto' && computedTop.includes('px') && parseInt(computedTop) < 5000) ? computedTop : '0px';
                    }
                    el.dataset.originalStyleTop = styleTop;
                    topPx = getPixelValue(styleTop, el);
                }
                sortKeyMap.set(el, { isDynamic, topPx, resolvedCustomTop });
            });

            // Sortierung basierend auf vorberechneten Keys
            stoerers.sort((a, b) => {
                const ka = sortKeyMap.get(a);
                const kb = sortKeyMap.get(b);

                // Dynamische Störer immer nach festen Störern
                if (ka.isDynamic && !kb.isDynamic) return 1;
                if (!ka.isDynamic && kb.isDynamic) return -1;
                if (ka.isDynamic && kb.isDynamic) return 0;

                // Beide sind feste Störer - numerische Sortierung
                return ka.topPx - kb.topPx;
            });

            // Positionierung
            let firstStoererOriginalTop = "0px";
            const triggerHeights = stoerers.map(el => getTriggerOuterHeightPx(el));

            // AI-Assistant-Toggle berücksichtigen (falls vorhanden) — READ-Phase
            const aiAssistantToggle = document.querySelector('.ai-assistant__toggle');
            let aiAssistantBottomPx = 0;
            let aiToggleTopFixed = 0;
            let aiToggleHeight = 0;
            if (aiAssistantToggle) {
                const aiRect = aiAssistantToggle.getBoundingClientRect();
                aiAssistantBottomPx = aiRect.bottom + window.scrollY;
                aiToggleTopFixed = parseFloat(aiAssistantToggle.style.top) || aiRect.top;
                aiToggleHeight = aiRect.height || 60;
            }

            stoerers.forEach((element, index) => {
                element.style.zIndex = stoerers.length - index;

                if (index === 0) {
                    // Vorberechnete Werte aus der READ-Phase (sortKeyMap) verwenden
                    const meta = sortKeyMap.get(element);
                    const customTop = meta ? meta.resolvedCustomTop : '';

                    if (customTop && customTop !== '') {
                        firstStoererOriginalTop = customTop;
                        // Setze die korrekte Position wenn sie fehlt
                        if (!element.style.top || element.style.top === '0px' || element.style.top === 'auto') {
                            element.style.top = firstStoererOriginalTop;
                        }
                    } else if (element.style.top && element.style.top !== '0px' && element.style.top !== 'auto') {
                        // Fallback: verwende existierende style.top
                        firstStoererOriginalTop = element.style.top;
                    } else if (element.dataset.originalStyleTop) {
                        // Fallback: verwende originalStyleTop
                        firstStoererOriginalTop = element.dataset.originalStyleTop;
                    }
                } else {
                    const isDynamicStoerer = element.classList.contains('article-info-nav-stoerer') || element.id === 'stoerer-130-1';

                    // Berechne maximale Top-Position, damit der Störer nicht über den unteren Bildschirmrand hinausragt
                    const elementTriggerHeight = triggerHeights[index] || 40;
                    const viewportHeight = window.innerHeight;
                    const bottomPadding = 20; // Sicherheitsabstand zum unteren Rand
                    const maxTopPx = viewportHeight - elementTriggerHeight - bottomPadding;

                    let calculatedTopPx = 0;

                    // Für dynamische Störer: Prüfe ob AI-Assistant vorhanden ist
                    if (isDynamicStoerer && aiAssistantToggle && aiAssistantBottomPx > 0) {
                        // AI-Assistant ist vorhanden - positioniere unter dem AI-Assistant-Toggle
                        calculatedTopPx = aiToggleTopFixed + aiToggleHeight + gapValuePx;
                    } else {
                        // Nutze die tatsächlich gerenderte Position des vorherigen Triggers
                        // (getBoundingClientRect liefert exakte Viewport-Koordinaten,
                        //  eliminiert Sub-Pixel-Fehler durch CSS-zu-Pixel-Konvertierung)
                        const prevElement = stoerers[index - 1];
                        const prevTrigger = prevElement.querySelector('.stoerer-trigger');
                        if (prevTrigger) {
                            calculatedTopPx = Math.ceil(prevTrigger.getBoundingClientRect().bottom) + gapValuePx;
                        } else {
                            // Fallback: vorheriges Element rect + Trigger-Höhe
                            const prevRect = prevElement.getBoundingClientRect();
                            calculatedTopPx = Math.ceil(prevRect.top + (triggerHeights[index - 1] || 40)) + gapValuePx;
                        }
                    }

                    // Begrenze die Position, damit der Störer nicht über den unteren Bildschirmrand hinausragt
                    const finalTopPx = Math.min(calculatedTopPx, maxTopPx);
                    element.style.top = `${finalTopPx}px`;
                }
            });
        });
    }

    // --- Edge-Position Check optimiert ---
    function checkEdgePositioning() {
        const edgeStoerers = document.querySelectorAll('.ce--stoerer[style*="left:"], .ce--stoerer[style*="right:"]');

        // WRITE-Phase 1: Klassen entfernen
        edgeStoerers.forEach(el => el.classList.remove('is-flush-left', 'is-flush-right'));

        // READ-Phase: Alle Positionen messen
        const windowWidth = window.innerWidth;
        const rects = Array.from(edgeStoerers).map(el => ({
            el,
            rect: el.getBoundingClientRect()
        }));

        // WRITE-Phase 2: Klassen basierend auf Messung setzen
        const tolerance = 2;
        rects.forEach(({ el, rect }) => {
            if (rect.left <= tolerance) {
                el.classList.add('is-flush-left');
            } else if (rect.right >= windowWidth - tolerance) {
                el.classList.add('is-flush-right');
            }
        });
    }

    // --- Hauptinitialisierung ---
    function initializeAllStoerers() {
        const allStoerers = document.querySelectorAll('.ce--stoerer.is-expandable');
        const stoererContainers = document.querySelectorAll('.content--element.ce_rsce_stoerer');

        allStoerers.forEach(stoerer => {
            const state = getStoererState(stoerer);

            // Event-Listener für Trigger-Klick
            const trigger = stoerer.querySelector('.stoerer-trigger');
            if (trigger && !trigger.dataset.listenerAttached) {
                addSafeEventListener(trigger, 'click', (event) => {
                    // Prüfe ob der Störer einen Content-Link hat und NICHT expandierbar ist
                    const hasContentLink = stoerer.parentElement.querySelector('a.stoerer-inner-wrapper');
                    const isExpandable = stoerer.classList.contains('is-expandable');

                    if (hasContentLink && !isExpandable) {
                        // Trigger den Link-Klick auf den stoerer-inner-wrapper
                        hasContentLink.click();
                        return;
                    }

                    // Touch-Handling hat Vorrang
                    if (handleTouchClick(event, stoerer)) {
                        return; // Touch-Handler hat das Event behandelt
                    }

                    // Desktop-Verhalten: Toggle
                    state.setInteracting(true);

                    if (state.isActive || state.isExpanded) {
                        state.collapse();
                        state.deactivate();
                    } else {
                        state.expand();
                        state.activate();
                    }

                    // Remove interaction flag
                    setTimeout(() => state.setInteracting(false), 50);
                });
                trigger.dataset.listenerAttached = 'true';
            }

            // Hover-Events (nur echte Desktop-Geräte)
            if (!stoerer.dataset.hoverListenerAttached) {
                addSafeEventListener(stoerer, 'mouseenter', () => {
                    if (isTouchDevice() || state.isInteracting || state.isActive) return;
                    state.expand();
                });

                addSafeEventListener(stoerer, 'mouseleave', () => {
                    if (isTouchDevice() || state.isInteracting || state.isActive) return;
                    state.collapse();
                });
                stoerer.dataset.hoverListenerAttached = 'true';
            }
        });

        stackFixedStoerers();
        checkEdgePositioning();

        // Ready-Klasse hinzufügen
        stoererContainers.forEach(container => container.classList.add('js-stoerer-ready'));

        // Größenänderungen beobachten (z. B. wenn Bilder/Lazyload fertig sind)
        const ro = ensureResizeObserver();
        if (ro) {
            allStoerers.forEach(stoerer => {
                const inner = stoerer.querySelector('.stoerer-inner-wrapper');
                if (inner && !observedWrappers.has(inner)) {
                    observedWrappers.add(inner);
                    ro.observe(inner);
                }
                // Bilder explizit beobachten
                stoerer.querySelectorAll('img').forEach(img => {
                    addSafeEventListener(img, 'load', () => {
                        if (hasActiveInteraction()) {
                            scheduleRecompute(120);
                        } else {
                            scheduleRecompute(30);
                        }
                    });
                });
            });
        }
    }

    // --- Event Listeners ---
    let resizeTimer;
    let recomputeTimer;
    const observedWrappers = new WeakSet();
    let globalResizeObserver = null;

    function hasActiveInteraction() {
        let active = false;
        stoererStates.forEach((state) => {
            if (state.isExpanded || state.isActive || state.isInteracting) {
                active = true;
            }
        });
        return active;
    }

    function scheduleRecompute(delay = 100) {
        clearTimeout(recomputeTimer);
        recomputeTimer = setTimeout(() => {
            if (hasActiveInteraction()) {
                // Während eines aktiven Interaktionszustands nicht repositionieren
                // und stattdessen kurz danach erneut versuchen
                scheduleRecompute(120);
                return;
            }
            initializeAllStoerers();
        }, delay);
    }

    function ensureResizeObserver() {
        if (!('ResizeObserver' in window)) return null;
        if (!globalResizeObserver) {
            globalResizeObserver = new ResizeObserver(() => {
                scheduleRecompute(50);
            });
        }
        return globalResizeObserver;
    }

    // Initialer Aufruf
    initializeAllStoerers();
    // Safeguard: kurz nach Layout erneut berechnen
    scheduleRecompute(80);

    // Resize (debounced)
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initializeAllStoerers, 250);
    });

    // Scroll-Event für dynamische Störer-Positionierung (z.B. wenn AI-Assistant seine Position ändert)
    let scrollTimer;
    window.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
            // Nur Stacking aktualisieren, nicht die gesamte Initialisierung
            stackFixedStoerers();
        }, 100);
    }, { passive: true });

    // Nach vollständigem Laden (inkl. Bilder/Fonts) erneut berechnen
    // Längere Verzögerung, damit der AI-Assistant-Toggle seine Position zuerst berechnen kann
    window.addEventListener('load', () => {
        scheduleRecompute(300);
        // Zusätzliche Neuberechnung nach 500ms für späte Initialisierungen
        setTimeout(() => {
            stackFixedStoerers();
        }, 500);
    });

    // Klick außerhalb (vereinfacht)
    addSafeEventListener(document, 'click', function (event) {
        const clickedStoerer = event.target.closest('.ce--stoerer.is-expandable');

        stoererStates.forEach((state, element) => {
            if (element !== clickedStoerer) {
                // Vereinfacht: Alle States zurücksetzen, unabhängig vom Gerät
                if (state.isExpanded || state.isActive) {
                    state.collapse();
                    state.deactivate();
                }
            }
        });
    });

    // Custom Event für dynamische Störer
    document.body.addEventListener('stoererAdded', function(e) {

        requestAnimationFrame(() => {
            // Zusätzliche Verzögerung für dynamische Störer aus theme.js
            // und um sicherzustellen, dass der AI-Assistant-Toggle seine Position zuerst berechnet hat
            setTimeout(() => {
                initializeAllStoerers();
                // Force-Update für Stacking nach dynamischer Erstellung
                // Längere Verzögerung, damit der AI-Assistant-Toggle Zeit hat, seine Position zu berechnen
                setTimeout(() => {
                    stackFixedStoerers();
                    checkEdgePositioning();
                    // Nochmals nach 300ms für späte AI-Assistant Initialisierungen
                    setTimeout(() => {
                        stackFixedStoerers();
                    }, 300);
                }, 150);
            }, 250);
        });
    });

});  
